export const onceOptions = {
  once: true,
  passive: false

}